// extracted by mini-css-extract-plugin
export default {"userRestrictedContainer":"UserRestrictedView-module__userRestrictedContainer--PsuUk","backToAllIssuesButton":"UserRestrictedView-module__backToAllIssuesButton--bj0gm"};